import React from "react";
import { motion } from "framer-motion";
import { profile } from "../data/content";
import { FiArrowDown, FiYoutube, FiMail } from "react-icons/fi";
import HeroPortrait from "./HeroPortrait";

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const item = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

export default function Hero() {
  return (
    <section
      id="home"
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div
        className="container hero-grid"
        style={{
          position: "relative",
          zIndex: 2,
          paddingTop: 96,
          display: "grid",
          gridTemplateColumns: "1.15fr 0.85fr",
          gap: 32,
          alignItems: "center",
        }}
      >
        <motion.div variants={container} initial="hidden" animate="show" className="hero-copy">
          <motion.div variants={item} className="eyebrow">
            Available for select projects &amp; mentorship
          </motion.div>

          <motion.h1
            variants={item}
            style={{ fontSize: "clamp(38px, 6vw, 72px)", marginBottom: 20 }}
          >
            Hi, I'm <span className="gradient-text">{profile.name}</span>
          </motion.h1>

          <motion.div
            variants={item}
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              marginBottom: 26,
              fontFamily: "var(--font-mono)",
              fontSize: 14,
              color: "var(--text-muted)",
            }}
          >
            {profile.roles.map((r) => (
              <span key={r} className="tag">
                {r}
              </span>
            ))}
          </motion.div>

          <motion.p
            variants={item}
            style={{ fontSize: 18, lineHeight: 1.7, color: "var(--text-muted)", maxWidth: 560, marginBottom: 40 }}
          >
            {profile.tagline} Based in {profile.location} — building products under{" "}
            <span style={{ color: "var(--text)" }}>Engineer Codewala</span>, and teaching developers
            how to ship on YouTube.
          </motion.p>

          <motion.div variants={item} style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
            <a
              href={profile.socials.youtube}
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              <FiYoutube size={18} /> Watch on YouTube
            </a>
            <a href={`mailto:${profile.email}`} className="btn">
              <FiMail size={16} /> Get in touch
            </a>
          </motion.div>
        </motion.div>

        <div className="hero-portrait-slot">
          <HeroPortrait />
        </div>
      </div>

      <motion.button
        onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, y: [0, 8, 0] }}
        transition={{ opacity: { delay: 1.2, duration: 0.6 }, y: { repeat: Infinity, duration: 1.8 } }}
        style={{
          position: "absolute",
          bottom: 36,
          left: "50%",
          transform: "translateX(-50%)",
          background: "none",
          border: "1px solid var(--border-strong)",
          borderRadius: "50%",
          width: 44,
          height: 44,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--text-muted)",
          zIndex: 2,
        }}
        aria-label="Scroll down"
      >
        <FiArrowDown />
      </motion.button>

      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 0.6 }}
        style={{
          position: "absolute",
          bottom: 92,
          left: "50%",
          transform: "translateX(-50%)",
          fontFamily: "var(--font-mono)",
          fontSize: 11,
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          color: "var(--text-dim)",
          zIndex: 2,
          whiteSpace: "nowrap",
        }}
      >
        Scroll to begin the journey
      </motion.span>

      <style>{`
        @media (max-width: 900px) {
          .hero-grid {
            grid-template-columns: 1fr !important;
            padding-top: 140px !important;
            text-align: center;
          }
          .hero-portrait-slot { order: -1; margin-bottom: 8px; }
          .hero-copy .eyebrow { justify-content: center; }
          .hero-copy > div { justify-content: center; }
        }
      `}</style>
    </section>
  );
}
